import { render, staticRenderFns } from "./PrintableCalendarSettings.vue?vue&type=template&id=3efbb5bc&scoped=true"
import script from "./PrintableCalendarSettings.ts?vue&type=script&lang=js&external"
export * from "./PrintableCalendarSettings.ts?vue&type=script&lang=js&external"
import style0 from "./PrintableCalendarSettings.scss?vue&type=style&index=0&id=3efbb5bc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efbb5bc",
  null
  
)

export default component.exports